<div class="app-shell">
    <app-toast-message-container class="app-toast-container"></app-toast-message-container>

    @if (isOffline()) {
    <div class="offline-banner">
        <span class="nav-link offline-indicator" aria-live="polite">DESCONECTADO</span>
    </div>
    }

    @if (auth.isAuthenticated()) {
    <nav #navbarRoot class="navbar navbar-expand-lg bg-body-tertiary">

        <div class="container-fluid">
            <a class="navbar-brand" [routerLink]="['/']">Logi Flow 360</a>
            <button id="navbarToggler" class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>


            <div class="collapse navbar-collapse" id="navbarSupportedContent" (click)="closeMobileMenuOnSelect($event)">

                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item dropdown" routerLinkActive="active"
                        [appAuthGroups]="[GroupNames.Configuracion, GroupNames.Precios]">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Configuración
                        </a>
                        <ul class="dropdown-menu">
                            <div [appAuthGroups]="[GroupNames.Configuracion]">

                                <li>
                                    <a class="dropdown-item"
                                        [routerLink]="'/configuracion/configuraction'">Configuración</a>
                                </li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li><a class="dropdown-item" title="Sucursales donde las guías son creadas y enviadas"
                                        [routerLink]="'/configuracion/sucursales'">Sucursales</a></li>
                                <li><a class="dropdown-item" [routerLink]="'/configuracion/choferes'">Choferes</a></li>
                                <li><a class="dropdown-item" [routerLink]="'/configuracion/vehiculos'">Vehículos</a>
                                </li>
                                <li><a class="dropdown-item" [routerLink]="'/configuracion/servicios'">Servicios</a>
                                </li>
                                <li>
                                    <a class="dropdown-item" [routerLink]="'/configuracion/motivos-no-entrega'">
                                        Motivos de
                                        no entrega
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item" [routerLink]="'/configuracion/tiposguia'">Tipos de guía</a>
                                </li>
                                <li><a class="dropdown-item" [routerLink]="'/configuracion/cordones'">Cordones</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li><a class="dropdown-item" [routerLink]="'/configuracion/impresoras'">Impresoras</a>
                                </li>
                            </div>

                            <div [appAuthGroups]="[GroupNames.Precios]">
                                <li>
                                    <a class="dropdown-item" [routerLink]="'/configuracion/listaprecios'">
                                        Lista de
                                        Precios
                                    </a>
                                </li>

                            </div>

                        </ul>

                    </li>
                    <li class="nav-item dropdown" routerLinkActive="active" [appAuthGroups]="[GroupNames.Clientes]">
                        <a class=" nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Clientes
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" [routerLink]="'/clientes/clientes'">Clientes</a></li>
                        </ul>
                    </li>
                    <li class="nav-item dropdown" routerLinkActive="active"
                        [appAuthGroups]="[GroupNames.Administrator]">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Seguridad
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" [routerLink]="'/seguridad/usuarios'">Usuarios</a></li>
                            <li><a class="dropdown-item" [routerLink]="'/seguridad/tokens'">Tokens</a></li>
                        </ul>
                    </li>

                    <li class="nav-item dropdown" routerLinkActive="active"
                        [appAuthGroups]="[GroupNames.Operaciones, GroupNames.Repartidores]">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Operaciones
                        </a>
                        <ul class="dropdown-menu">
                            <div [appAuthGroups]="[GroupNames.Operaciones]">

                                <li><a class="dropdown-item" [routerLink]="'/operaciones/guias'">Guías</a></li>
                                <li><a class="dropdown-item" [routerLink]="'/operaciones/guias/0'">Nueva guía</a></li>
                                <li><a class="dropdown-item" [routerLink]="'/tracking'">Seguimiento</a></li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li>
                                    <a class="dropdown-item" [routerLink]="'/operaciones/cambiar-estado-guia'">
                                        Cambiar estado
                                        de las guías
                                    </a>
                                </li>
                                <li>
                                    <hr class="dropdown-divider">
                                </li>
                                <li><a class="dropdown-item" [routerLink]="'/operaciones/hojas-ruta'">Hojas de ruta</a>
                                </li>
                                <li>
                                    <a class="dropdown-item" [routerLink]="'/operaciones/cargar-camion'">Cargar
                                        camión</a>
                                </li>
                                <li>
                                    <a class="dropdown-item" [routerLink]="'/operaciones/recibir-hoja-ruta'">
                                        Recibir Hojas de
                                        Ruta
                                    </a>
                                </li>
                                <li><a class="dropdown-item" [routerLink]="'/operaciones/repartos'">Repartos</a></li>
                                <li [appFeatureEnabled]="['optimizacionRuteoDeFlota']"><a class="dropdown-item"
                                        [routerLink]="'/operaciones/repartos-flota'">Repartos
                                        (Flota)</a></li>
                            </div>
                            <div [appAuthGroups]="[GroupNames.Repartidores]">

                                <li><a class="dropdown-item" [routerLink]="'/repartidor/repartir'">Repartir</a></li>
                            </div>
                        </ul>
                    </li>

                    <li class="nav-item dropdown" routerLinkActive="active" [appAuthIsLogiFlow]
                        [appAuthGroups]="[GroupNames.Administrator]"
                        [appAuthIsLogiFlow]>
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Administración
                        </a>
                        <ul class="dropdown-menu">
                            <li><a class="dropdown-item" [routerLink]="'/admin/tenants'">Tenants</a></li>
                            <li><a class="dropdown-item" [routerLink]="'/admin/paises'">Paises</a></li>
                        </ul>
                    </li>

                </ul>


                <div class="navbar-search ms-lg-auto me-lg-3 my-2 my-lg-0">
                    <div class="input-group input-group-sm">
                        <span class="input-group-text" id="menuSearchLabel">
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </span>
                        <input #menuSearch type="search" class="form-control" placeholder="Buscar menú (Ctrl+B)"
                            aria-label="Buscar menú" aria-describedby="menuSearchLabel"
                            [value]="menuSearchQuery()" (input)="updateMenuSearch(menuSearch.value)"
                            (focus)="updateMenuSearch(menuSearch.value)"
                            (keydown)="handleMenuSearchKeydown($event, menuSearch)"
                            (keydown.escape)="clearMenuSearch(menuSearch)">
                        @if (menuSearch.value) {
                        <button type="button" class="btn btn-outline-secondary" (click)="clearMenuSearch(menuSearch)"
                            aria-label="Limpiar búsqueda del menú">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                        }
                    </div>
                    @if (menuSearchQuery().trim() && menuSearchResults().length) {
                    <div class="dropdown-menu show navbar-search__menu shadow">
                        @for (result of menuSearchResults(); track result.href; let index = $index) {
                        <button type="button" class="dropdown-item"
                            [attr.data-menu-search-index]="index"
                            [class.active]="menuSearchActiveIndex() === index"
                            [attr.aria-selected]="menuSearchActiveIndex() === index"
                            (click)="selectMenuResult(result, menuSearch)">
                            <strong class="d-block navbar-search__item-label">{{ result.label }}</strong>
                            @if (result.title) {
                            <small class="text-muted d-block navbar-search__item-title">{{ result.title }}</small>
                            }
                            <small class="text-muted d-block navbar-search__item-url">{{ result.url }}</small>
                        </button>
                        }
                    </div>
                    } @else if (menuSearchQuery().trim()) {
                    <div class="dropdown-menu show navbar-search__menu shadow">
                        <span class="dropdown-item-text text-muted">Sin resultados</span>
                    </div>
                    }
                </div>

                <ul class="navbar-nav">

                    <li class="nav-item dropdown navbar-profile-item">
                        <a class="nav-link dropdown-toggle d-flex justify-content-end" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false" style="min-width: 200px;">
                            {{auth.getName()}} ({{auth.getSucursalName()}})
                        </a>
                        <ul class="dropdown-menu">
                            <li>
                                <a class="dropdown-item hand" (click)="changeSucursal()"
                                    [appAuthGroups]="[GroupNames.Operaciones]">Cambiar Sucursal</a>
                            </li>
                            <li>
                                <a class="dropdown-item hand" (click)="configurePrinters()"
                                    [appAuthGroups]="[GroupNames.Operaciones]">Configurar Impresoras</a>
                            </li>
                            <li [appAuthGroups]="[GroupNames.Operaciones]">
                                <hr class=" dropdown-divider">
                            </li>
                            <li><a class="dropdown-item" [routerLink]="'/perfil'">Perfil</a></li>
                            <li><a class="dropdown-item" [routerLink]="'/recursos'">Recursos</a></li>
                            <li><a class="dropdown-item" [routerLink]="'/auth/logout'">Salir</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    }

    <main class="app-content">
        <div class="mt-2 m-4">
            <router-outlet />
        </div>
    </main>

    <footer class="app-footer">
        <div class="app-footer__content">
            <a target="_blank" href="https://www.logiflow360.com.ar">© 2026 LogiFlow 360</a>
        </div>
    </footer>

    @if (auth.isAuthenticated()) {
    <app-chat-agent />
    }
</div>